import {metadaApi} from '@dms/api/base';

import {
  GetSupplierResponse,
  GetSupplierRequest,
  GetSupplierRequestSchema,
  GetSupplierResponseSchema,
  GetSupplierDiscountGroupsResponse,
  GetSupplierDiscountGroupsRequest,
  GetSupplierDiscountGroupsRequestSchema,
  GetSupplierDiscountGroupsResponseSchema,
  PutRefreshSupplierDiscountGroupsResponse,
  PutRefreshSupplierDiscountGroupsRequest,
  PutRefreshSupplierDiscountGroupsRequestSchema,
  PutRefreshSupplierDiscountGroupsResponseSchema,
  GetSupplierDiscountGroupResponse,
  GetSupplierDiscountGroupRequest,
  GetSupplierDiscountGroupRequestSchema,
  GetSupplierDiscountGroupResponseSchema,
  PatchSupplierDiscountGroupResponse,
  PatchSupplierDiscountGroupRequest,
  PatchSupplierDiscountGroupRequestSchema,
  PatchSupplierDiscountGroupResponseSchema,
  BulkPatchSupplierDiscountGroupsResponse,
  BulkPatchSupplierDiscountGroupsRequest,
  BulkPatchSupplierDiscountGroupsRequestSchema,
  BulkPatchSupplierDiscountGroupsResponseSchema,
} from './types';

export const metadaWarehouseSupplierApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getSupplier: build.query<GetSupplierResponse, GetSupplierRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/supplier/${queryArg.supplierId}`,
        queryArg,
      }),
      extraOptions: {
        requestSchema: GetSupplierRequestSchema,
        responseSchema: GetSupplierResponseSchema,
      },
    }),
    getSupplierDiscountGroups: build.query<
      GetSupplierDiscountGroupsResponse,
      GetSupplierDiscountGroupsRequest
    >({
      query: (queryArg) => ({
        url: 'warehouse/v1/supplier-discount-group',
        params: {
          supplierId: queryArg.supplierId,
          authorizationProfileId: queryArg.authorizationProfileId,
          discountGroupId: queryArg.discountGroupId,
        },
        queryArg,
      }),
      providesTags: ['supplierDiscountGroups'],
      extraOptions: {
        requestSchema: GetSupplierDiscountGroupsRequestSchema,
        responseSchema: GetSupplierDiscountGroupsResponseSchema,
      },
    }),
    refreshSupplierDiscountGroups: build.mutation<
      PutRefreshSupplierDiscountGroupsResponse,
      PutRefreshSupplierDiscountGroupsRequest
    >({
      query: (queryArg) => ({
        url: 'warehouse/v1/supplier-discount-group/refresh',
        method: 'PUT',
        queryArg,
      }),
      extraOptions: {
        requestSchema: PutRefreshSupplierDiscountGroupsRequestSchema,
        responseSchema: PutRefreshSupplierDiscountGroupsResponseSchema,
      },
    }),
    getSupplierDiscountGroup: build.query<
      GetSupplierDiscountGroupResponse,
      GetSupplierDiscountGroupRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/supplier-discount-group/${queryArg.supplierDiscountGroupId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: ['supplierDiscountGroups'],
      extraOptions: {
        requestSchema: GetSupplierDiscountGroupRequestSchema,
        responseSchema: GetSupplierDiscountGroupResponseSchema,
      },
    }),
    patchSupplierDiscountGroup: build.mutation<
      PatchSupplierDiscountGroupResponse,
      PatchSupplierDiscountGroupRequest
    >({
      query: (queryArg) => ({
        url: 'warehouse/v1/supplier-discount-group',
        method: 'PATCH',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: ['supplierDiscountGroups'],
      extraOptions: {
        requestSchema: PatchSupplierDiscountGroupRequestSchema,
        responseSchema: PatchSupplierDiscountGroupResponseSchema,
      },
    }),
    bulkPatchSupplierDiscountGroups: build.mutation<
      BulkPatchSupplierDiscountGroupsResponse,
      BulkPatchSupplierDiscountGroupsRequest
    >({
      query: (queryArg) => ({
        url: 'warehouse/v1/supplier-discount-group/bulk-edit',
        method: 'PATCH',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: ['supplierDiscountGroups'],
      extraOptions: {
        requestSchema: BulkPatchSupplierDiscountGroupsRequestSchema,
        responseSchema: BulkPatchSupplierDiscountGroupsResponseSchema,
      },
    }),
  }),
});

export const {
  useGetSupplierQuery,
  useGetSupplierDiscountGroupsQuery,
  useRefreshSupplierDiscountGroupsMutation,
  useGetSupplierDiscountGroupQuery,
  usePatchSupplierDiscountGroupMutation,
  useBulkPatchSupplierDiscountGroupsMutation,
} = metadaWarehouseSupplierApi;
